export default __webpack_public_path__ + "static/media/one-courageous-voice-011-4738-00.b1cf4412.jpg";